import React, { useEffect, useRef, useState } from "react";
import {
  Box,
} from "@mui/material";
import FileMenu from "./file_annotator/LeftMenu";
import FileEditor from "./file_annotator/FileEditor";
import '../assets/styles/fileannotator.css';
import { getCollectionFileList, getAnnotationFile,updateFileAnnotation } from "../assets/constants/global_apis";
import AlertPopup, { triggerAlert } from './AlertMessage';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useSelector } from "react-redux";

const FileAnnotator = ({ handleCloseFileAnnotator,fileAnnotatorOpen,collectionId,schemaJsonList, setSchemaJsonList,getCollectionSchemaData }) => {
  const [filesList, setFilesList] = useState([])
  const [initialFilesList, setInitialFilesList] = useState([])
  const [selectedFile, setSelectedFile] = useState('')
  const [selectedFileIndx, setSelectedFileIndx] = useState(0)
  const [selectedFileUrl, setSelectedFileUrl] = useState('')
  const [textFileVal, setTextFileVal] = useState()
  const [searchFileName, setSearchFileName] = useState('')
  const [initalTextData, setInitialTextData] = useState('')
  const [initialJsonData, setInitialJsonData] = useState({})
  const [textAreaData, setTextAreaData] = useState('')
  const [textSections, setTextSections] = useState([])
  const [selectedTextSection, setSelectedTextSection] = useState(0)
  const [jsonSections, setJsonSections] = useState([])
  const [loading, setLoading] = useState([])
  const [selectedJsonSection, setSelectedJsonSection] = useState(0)
  const [sectionJSONData, setSectionJsonData] = useState({});
  const [schemaResult, setschemaResult] = useState(null);
  const collections = useSelector(state => state.collections);
  const editorRef = useRef(null);

  const theme = createTheme({
    typography: {
      button: {
        textTransform: 'none'
      }
    }
  });

  useEffect(() => {
    if(fileAnnotatorOpen==true){
      setLoading(true);
    getCollectionFileList(collectionId).then((response) => {
      setInitialFilesList(response)
      let fileNameList=[];
      response.forEach((file) => {
        fileNameList.push(file.path)
      });
      setFilesList(fileNameList)
      for (let i = 0; i < fileNameList.length; i++) {
        if (fileNameList[i].includes('.pdf')) {
          handleFileSelect(fileNameList[i],i,response[i].backendId);
          break;
        }
      }
    }).catch((error) => {
      setLoading(false);
      triggerAlert('error', error.message)
    })
  }
  }, [fileAnnotatorOpen])

  const removeFirstAndLastQuote = (inputString) => {
    if ((inputString.startsWith('"') && inputString.endsWith('"')) || 
        (inputString.startsWith("'") && inputString.endsWith("'"))) {
      return inputString.slice(1, -1); // Remove first and last characters
    }
    return inputString; // Return unchanged if no quotes
  };

  const handleFileSelect = (file,indx,backend_id) => {
    setLoading(true)
    setSelectedFile(file);
    setSelectedFileIndx(indx)
    setSearchFileName('')
    setInitialTextData('')
    setTextAreaData('')
    setTextSections([])
    setSelectedFileUrl('');
    setInitialJsonData({})
    setJsonSections([])
    setSelectedTextSection(0)
    setSectionJsonData({})


    backend_id=backend_id ? backend_id: initialFilesList[indx].backendId;
    getAnnotationFile(backend_id,collectionId,file).then((blob) => {
      setSelectedFileUrl(URL.createObjectURL(blob));
      getAnnotationFile(backend_id,collectionId,file.replace('.pdf', '.input.txt')).then((textdata) => {
        setInitialTextData(textdata)
        textdata=removeFirstAndLastQuote(textdata);
        setTextSections(textdata.split('===SECTION-BREAK==='))
      }).catch((err) => triggerAlert("Error fetching Text:", err.message));

      getAnnotationFile(backend_id,collectionId,file.replace('.pdf', '.txt')).then((fulltextdata) => {
        setTextAreaData(fulltextdata)
      }).catch((err) => triggerAlert("Error fetching Text:", err.message));

      getAnnotationFile(backend_id,collectionId,file.replace('.pdf', '.output.json')).then((jsondata) => {
        setInitialJsonData(jsondata)
        setJsonSections(jsondata,()=>{
          handleSectionSelection(0);
        })
        setSelectedTextSection(0)
        setSectionJsonData(jsondata[0])
      }).catch((err) => triggerAlert("Error fetching Json:", err.message));
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      triggerAlert('error', "Error in fetching PDF");
    });
  }
  
  const handleSectionSelection=(indxVal)=>{
    setSectionJsonData([])
    setSelectedTextSection(parseInt(indxVal))
    if(jsonSections[indxVal]!=undefined && Object.keys(jsonSections[indxVal]).length>0 && schemaJsonList[indxVal] && Object.keys(schemaJsonList[indxVal]).length>0) {
    handleValidation(schemaJsonList[indxVal].schema,jsonSections[indxVal])
    setSectionJsonData(jsonSections[indxVal])
    }else{
      setschemaResult({...schemaResult,error:"Section Doesn't have schema"})
    }
  }


  const handleMovePreviousSection=()=>{
    if(selectedTextSection-1>=0){
      let sectionIndx=selectedTextSection-1;
      handleSectionSelection(sectionIndx);
      triggerAlert('success', "Section " + (parseInt(sectionIndx)+1))
  }else{
    triggerAlert('error', "There is no negative index section");
  }
  }
  const handleMoveNextSection=()=>{
    if(selectedTextSection+1<jsonSections.length){
      let sectionIndx=selectedTextSection+1;
      handleSectionSelection(sectionIndx);
      triggerAlert('success', "Section " + (parseInt(sectionIndx)+1))
    }else{
      triggerAlert('error', "No more section available");
    }
  }
  const handleMoveNextFile=()=>{
    for (let i = selectedFileIndx+1; i < filesList.length; i++) {
      if (filesList[i].includes('.pdf')) {
        handleFileSelect(filesList[i],i);
        triggerAlert('success', "File " + filesList[i].split('/').pop())
        return;
      }
    }
    triggerAlert('error', "No more File Available");
  }
  const handleMovePreviousfile=()=>{
    for (let i = selectedFileIndx-1; i >=0; i--) {
      if (filesList[i].includes('.pdf')) {
        handleFileSelect(filesList[i],i);
        triggerAlert('success', "File " + filesList[i].split('/').pop())
        return;
      }
    }
    triggerAlert('error', "There is no negative index section");
  }

  
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey) {
        switch (event.key) {
          case "ArrowLeft":
            handleMovePreviousSection();
            break;
          case "ArrowRight":
            handleMoveNextSection();
            break;
          case "ArrowUp":
            handleMovePreviousfile();
            break;
          case "ArrowDown":
            handleMoveNextFile();
            break;
          default:
            break;
        }
      }
    };

    // Attach event listener
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedTextSection,jsonSections,selectedFile,selectedFileIndx]);


  const validateJsonAgainstSchema = (schema, json, path = "root") => {
    let missingData = [];
    let unmatchedData = [];
    let mismatchData = [];

    if (!schema) {
      return { error: "Schema not available" };
    }

    const schemaType = schema.type;

    if (schemaType === "object") {
      if (typeof json !== "object" || Array.isArray(json)) {
        mismatchData.push(path);
        return { missingData, unmatchedData, mismatchData };
      }

      const requiredFields = schema.required || [];
      const properties = schema.properties || {};

      // Check for missing required fields
      requiredFields.forEach((key) => {
        const currentPath = `${path}.${key}`;
        if (!(key in json)) {
          missingData.push(currentPath);
        }
      });

      // Validate properties
      for (const key in properties) {
        const currentPath = `${path}.${key}`;
        if (key in json) {
          const propertySchema = properties[key];
          const validationschemaResult = validateJsonAgainstSchema(
            propertySchema,
            json[key],
            currentPath
          );
          missingData = missingData.concat(validationschemaResult.missingData);
          unmatchedData = unmatchedData.concat(validationschemaResult.unmatchedData);
          mismatchData = mismatchData.concat(validationschemaResult.mismatchData);
        } else {
          unmatchedData.push(currentPath);
        }
      }

      // Check for extra fields in JSON not defined in schema
      for (const key in json) {
        if (!(key in properties)) {
          unmatchedData.push(`${path}.${key}`);
        }
      }
    } else if (schemaType === "array") {
      if (!Array.isArray(json)) {
        mismatchData.push(path);
        return { missingData, unmatchedData, mismatchData };
      }

      const itemSchema = schema.items;
      json.forEach((item, index) => {
        const currentPath = `${path}[${index}]`;
        const itemValidation = validateJsonAgainstSchema(
          itemSchema,
          item,
          currentPath
        );
        missingData = missingData.concat(itemValidation.missingData);
        unmatchedData = unmatchedData.concat(itemValidation.unmatchedData);
        mismatchData = mismatchData.concat(itemValidation.mismatchData);
      });
    } else {
      // Primitive types
      if (typeof json !== schemaType) {
        mismatchData.push(path);
      }
    }

    return { missingData, unmatchedData, mismatchData };
  };

  const handleValidation = (schemaData, validatJson) => {
    try {
      const validationschemaResult = validateJsonAgainstSchema(schemaData, validatJson);
      if (
        validationschemaResult.missingData.length === 0 &&
        validationschemaResult.unmatchedData.length === 0 &&
        validationschemaResult.mismatchData.length === 0
      ) {
        setschemaResult({ success: "Schema and JSON match perfectly!" });
      } else {
        setschemaResult(validationschemaResult);
      }
    } catch (error) {
      setschemaResult({ error: "Invalid JSON or Schema" });
    }
  };

  const handleSaveAnnotation=(type)=>{
    let reqData={};
    if(type === "text") {
      let finalInputText=textSections.join("\n===SECTION-BREAK===\n");
      reqData={input_txt:finalInputText,
        collection_id:collectionId,
        backend_id:initialFilesList[selectedFileIndx].backendId,
        output_json:[],
        path:selectedFile
      }
    }else{
      let jsonData=[...jsonSections];
      const updatedJson = editorRef?.current?.get();
      jsonData[selectedTextSection]=updatedJson;
      reqData={input_txt:'',
        collection_id:collectionId,
        backend_id:initialFilesList[selectedFileIndx].backendId,
        output_json:jsonData,
        path:selectedFile
      }
      setJsonSections(jsonData);
    }
    updateFileAnnotation(reqData).then((response)=>{
      triggerAlert('success', 'Annotation saved successfully')
    }).catch((error)=>{
      triggerAlert('error', `Error in saving Annotation ${error.message}`);
    })
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex", height: "100vh", padding: 0 }} className={'file-annotator-container'} >
        <AlertPopup />
        <FileMenu
          filesList={filesList}
          setSelectedFile={setSelectedFile}
          selectedFile={selectedFile}
          triggerAlert={triggerAlert}
          handleFileSelect={handleFileSelect}
        />
        <FileEditor
          handleCloseFileAnnotator={handleCloseFileAnnotator}
          selectedFileUrl={selectedFileUrl}
          handleFileSelect={handleFileSelect}
          setSelectedFile={setSelectedFile}
          searchFileName={searchFileName}
          setSearchFileName={setSearchFileName}
          triggerAlert={triggerAlert}
          sectionJSONData={sectionJSONData}
          setSectionJsonData={setSectionJsonData}
          textAreaData={textAreaData}
          textSections={textSections}
          selectedTextSection={selectedTextSection}
          setSelectedTextSection={setSelectedTextSection}
          setTextAreaData={setTextAreaData}
          setTextSections={setTextSections}
          setSelectedJsonSection={setSelectedJsonSection}
          setJsonSections={setJsonSections}
          loading={loading}
          setLoading={setLoading}
          jsonSections={jsonSections}
          handleSectionSelection={handleSectionSelection}
          selectedJsonSection={selectedJsonSection}
          schemaJsonList={schemaJsonList}
          setSchemaJsonList={setSchemaJsonList}
          getCollectionSchemaData={getCollectionSchemaData}
          schemaResult={schemaResult}
          handleSaveAnnotation={handleSaveAnnotation}
          editorRef={editorRef}
          collectionId={collectionId}
        />
      </Box>
    </ThemeProvider>
  );
};

export default FileAnnotator;
